export default function (
  value: number,
  lowerBound: number,
  upperBound: number,
) {
  return Math.max(Math.min(value, upperBound), lowerBound)
}
